// extracted by mini-css-extract-plugin
export default {"zoomModal":"a3-z","image":"b3-z","button":"c3-z","isOverlayShown":"d3-z"};